import * as React from "react";
import * as styles from "../block/block.module.scss";

/**
 * @type {Object} 「UI:atoms - ブロック 記事カード アーカイブ一覧 ホーム用 コンポーネント」DOMです。
 * @return {Object} DOMを返します。
 * @param {String} url slugを受け取るための引数です。
 * @param {Object} children 子コンポーネントを受け取るための引数です。任意の要素を渡します。
 * @param {String} title 記事タイトルを受け取るための引数です。
 * @param {String} description 説明文を受け取るための引数です。
 * @param {Object} tags キーワード（タグ）を受け取るための引数です。
 * @param {Date} publishDate 投稿日を受け取るための引数です。
 * @param {String} publishDateJP 指定した日付のフォーマットに変換した投稿日を受け取るための引数です。
 * @param {Date} updatedAt 最終更新日を受け取るための引数です。
 * @param {String} updatedAtJP 指定した日付のフォーマットに変換した最終更新日を受け取るための引数です。
 *
 */

const ArticleCardHome = ({
  children,
  url,
  target,
  title,
  description,
  explanation,
  tags,
  publishDate,
  publishDateJP,
  updatedAt,
  updatedAtJP,
}) => {
  return (
    <a href={url} className={`${styles.articleCard} ${styles.home}`} target={target}>
      <article>
        {children}
        <div className={`${styles.content}`}>
          {title !== null && <h3>{title}</h3>}
          {description !== null && <p>{description}</p>}
          {explanation !== null && <p style={{
            overflow: "hidden",
            WebkitLineClamp: "none"
          }}>{explanation}</p>}
          {tags !== null && (
            <ul className={`${styles.tagList}`}>
              {tags.map(({ tagName, id }) => {
                return (
                  <li key={id}>
                    <span>{tagName}</span>
                  </li>
                );
              })}
            </ul>
          )}
          <ul className={`${styles.post}`}>
            {(publishDate !== null || publishDateJP !== null) && (
              <li key={"post"}>
                投稿日 :{" "}
                <time itemProp="datePublished" dateTime={publishDate}>
                  {publishDateJP}
                </time>
              </li>
            )}
            {(updatedAt !== null || updatedAtJP !== null) && (
              <li key={"lastUpdate"}>
                最終更新日 :{" "}
                <time itemProp="datePublished" dateTime={updatedAt}>
                  {updatedAtJP}
                </time>
              </li>
            )}
          </ul>
        </div>
      </article>
    </a>
  );
};

export default ArticleCardHome;
